import React from "react";
import { View } from "react-native";
import { useUnitReader } from "./units";

type GapProps = {
    gap?: number | string;
    mode?: "vertical" | "horizontal";
};
const Gap: React.FC<GapProps> = ({ gap, mode }) => {
    const unitReader = useUnitReader();
    const effectiveGap = unitReader(gap);
    return (
        <View
            style={{
                height: mode !== "horizontal" ? effectiveGap : 0,
                width: mode !== "vertical" ? effectiveGap : 0,
                flexShrink: 0,
                flexGrow: 0,
            }}
        />
    );
};

export default Gap;
